module.exports = __webpack_public_path__ + "static/AdblockRecovery-354f494c2caee010f84aaa49c2d0fe64.png";